export default {
  MuiAvatar: {
    styleOverrides: {
      colorDefault: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
      }
    }
  }
};
